import { useState } from 'react';
import { ScreenFrame } from '@/components/Screen';
import { EntityCard, EntityList, SectionCard } from '@/components/DataList';
import { tahweel } from '@/api/endpoints';
import { errorMessage, pickList } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import {
  Button,
  Empty,
  ErrorBox,
  Form,
  Input,
  Loading,
} from '@/components/ui';
import { required, str } from '@/utils/format';

export function DebtsScreen() {
  const state = useAsync(
    () => tahweel.debts(),
    (p) => pickList(p, 'debts', 'items', 'data'),
  );

  const [customerId, setCustomerId] = useState('');
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  async function save() {
    const miss = required({ customerId, amount }, ['customerId', 'amount']);
    if (miss) {
      setMsg(miss);
      return;
    }
    setBusy(true);
    const res = await tahweel.saveDebt({
      customer_id: customerId,
      amount: Number(amount),
      note,
    });
    setBusy(false);
    setMsg(res.success ? 'تم تسجيل الدين.' : errorMessage(res));
    if (res.success) state.reload();
  }

  async function settle(id: unknown) {
    const res = await tahweel.settleDebt({ id, debt_id: id });
    if (!res.success) {
      window.alert(errorMessage(res));
      return;
    }
    state.reload();
  }

  if (state.loading) return <Loading />;
  if (state.error) return <ErrorBox message={state.error} onRetry={state.reload} />;

  const list = state.data ?? [];

  return (
    <ScreenFrame mode="customer" title="الديون">
      <SectionCard title="إضافة دين">
        <Form onSubmit={() => void save()}>
          <Input
            label="معرّف الزبون"
            value={customerId}
            onChange={(e) => setCustomerId(e.target.value)}
            required
          />
          <Input
            label="المبلغ"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            inputMode="decimal"
            required
          />
          <Input label="ملاحظة" value={note} onChange={(e) => setNote(e.target.value)} />
          {msg ? <p className="ok">{msg}</p> : null}
          <Button type="submit" disabled={busy}>
            إضافة دين
          </Button>
        </Form>
      </SectionCard>

      {list.length === 0 ? (
        <Empty title="لا توجد ديون" />
      ) : (
        <EntityList>
          {list.map((d, i) => (
            <EntityCard
              key={str(d.id, String(i))}
              title={str(d.customer_name ?? d.customer_id)}
              amount={d.amount ?? d.remaining}
              status={d.status}
              actions={
                <Button type="button" variant="secondary" onClick={() => void settle(d.id)}>
                  تسوية
                </Button>
              }
            />
          ))}
        </EntityList>
      )}
    </ScreenFrame>
  );
}
